import {
	IconPassport,
	IconPerson,
	IconPin,
	IconTime,
	IconTimelineStop,
} from '@flixbus/honeycomb-icons-react';

import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

import { CREATE_BREAKDOWN_FLOW_TEXT } from '../texts';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * @typedef {import('./summarySectionsRegistry').SummaryRow} SummaryRow
 */

/**
 * Build the row list for the Summary "Replacement driver info" accordion.
 *
 * @param {object} data
 * @returns {SummaryRow[]}
 */
export const deriveReplacementDriverInfoRows = (data) => {
	const driver = data?.replacementDriver;
	const inbound = data?.replacementInboundTraveling;

	if (!driver && !inbound) return [];

	return [
		{
			label: LABELS.departureLocation,
			value: inbound?.fromCityName ?? '',
			icon: IconPin,
		},
		{
			label: LABELS.replacementDriverName,
			value: driver?.fullName ?? '',
			icon: IconPerson,
		},
		{
			label: LABELS.replacementDriverId,
			value: driver?.driverCard ?? driver?.id ?? '',
			icon: IconPassport,
		},
		{
			label: LABELS.replacementEtd,
			value: formatSummaryDateTime(inbound?.fromTimestamp),
			icon: IconTime,
		},
		{
			label: LABELS.replacementEta,
			value: formatSummaryDateTime(inbound?.toTimestamp),
			icon: IconTimelineStop,
		},
	];
};
